import { render, staticRenderFns } from "./vpl-table.vue?vue&type=template&id=0c48d23a&scoped=true&"
import script from "./vpl-table.vue?vue&type=script&lang=js&"
export * from "./vpl-table.vue?vue&type=script&lang=js&"
import style0 from "./vpl-table.vue?vue&type=style&index=0&id=0c48d23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48d23a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
